module.exports = __webpack_public_path__ + "app/principal/modals/modal-delete-principal-1hbuxQEo.html";